import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const ASSOCIATED_CLAIMLINE_LOADING = 'ASSOCIATED_CLAIMLINE_LOADING'
export const ASSOCIATED_CLAIMLINE_SUCCESS = 'ASSOCIATED_CLAIMLINE_SUCCESS'
export const ASSOCIATED_CLAIMLINE_FAILED = 'ASSOCIATED_CLAIMLINE_FAILED'

export const fetchAssociatedClaimLines = (associatedClaimsObj) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/claims/${NgrxAuth.memberId}/AssociatedClaims`,
        prefix: 'ASSOCIATED_CLAIMLINE',
        method: 'post',
        mock: false,
        query: associatedClaimsObj
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/associatedClaimLinesActions.js